import api from "../../config/api";
import { handleApiError } from "@/utils/ErrorHandler";

const state = {
    workgroupPreferences: null,
    loading: false,
    error: null,
    saving: false,
};

const mutations = {
    SET_WORKGROUP_PREFERENCES(state, data) {
        state.workgroupPreferences = data;
    },
    SET_LOADING(state, value) {
        state.loading = value;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_SAVING(state, value) {
        state.saving = value;
    },
};

const actions = {
    async fetchWorkgroupPreferences({ commit }, { workgroupid, cmd = "editworkgroup", accordopt = "workgrouppreferences" }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.get(`/manageworkgroup`, {
                params: {
                    workgroupid,
                    cmd,
                    accordopt,
                },
            });
            // API returns { output: { rules: [], existing_rules: [] } }
            const data = response.data?.output || response.data?.data || null;
            commit("SET_WORKGROUP_PREFERENCES", data);
            return data;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch workgroup preferences");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async saveWorkgroupPreferenceRule({ commit }, { workgroupid, locationid, rulenumber, ruleinfoarray, cmd = "saverule" }) {
        commit("SET_SAVING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.post(`/manageworkgroupajax`, {
                cmd,
                workgroupid,
                locationid,
                rulenumber,
                ruleinfoarray,
            });
            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to save workgroup preference rule");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_SAVING", false);
        }
    },

    async removeWorkgroupPreferenceRules({ commit }, { workgroupid, locationid, ruleidsarray, cmd = "removerule" }) {
        commit("SET_SAVING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.post(`/manageworkgroupajax`, {
                cmd,
                workgroupid,
                locationid,
                ruleidsarray,
            });
            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to remove workgroup preference rules");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_SAVING", false);
        }
    },
};

const getters = {
    workgroupPreferences: (state) => state.workgroupPreferences,
    workgroupPreferencesLoading: (state) => state.loading,
    workgroupPreferencesError: (state) => state.error,
    workgroupPreferencesSaving: (state) => state.saving,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
